import { useState } from "react";
import { motion } from "framer-motion";

const containerVariants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.2 } },
};

const itemVariants = {
    hidden: { opacity: 0, scale: 0.8, y: 20 },
    visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.4 } },
};

export default function VideoGrid({ videos, onSelect }) {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    return (
        <motion.section
            className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 px-4 md:px-20 mt-12 max-w-6xl mx-auto"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
        >
            {videos.map((v, i) => (
                <motion.div
                    key={i}
                    onClick={() => onSelect(v.videoId)}
                    onMouseEnter={() => setHoveredIndex(i)}
                    onMouseLeave={() => setHoveredIndex(null)}
                    className="relative cursor-pointer rounded-lg overflow-hidden transition-transform"
                    whileHover={{ scale: 1.05 }}
                    variants={itemVariants}
                >
                    <div className="relative w-full aspect-video border-4 border-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl">

                        <img
                            src={v.thumb}
                            alt={v.title}
                            className="absolute inset-0 w-full h-full object-cover"
                        />

                    </div>

                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                        <div className="w-16 h-16 bg-white bg-opacity-70 rounded-full flex items-center justify-center">
                            <svg
                                className="w-8 h-8 text-[#b5435f]"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path d="M8 5v14l11-7z" />
                            </svg>
                        </div>
                    </div>
                    <div className="p-3">
                        <p className="font-medium text-left line-clamp-2">
                            {v.title}
                        </p>
                    </div>
                </motion.div>
            ))}
        </motion.section>
    );
}